import { z } from 'zod';
import { clientTypeSchema, userRoleSchema } from './enums.js';
import { permissionSchema } from './permission.js';

const phoneRegex = /^[+0-9 ().-]{6,20}$/;
const passwordMinLength = 8;

export const signupSchema = z.object({
  firstName: z.string().trim().min(1, 'Prénom requis').max(80),
  lastName: z.string().trim().min(1, 'Nom requis').max(80),
  email: z.string().trim().toLowerCase().email('Email invalide'),
  phone: z.string().trim().regex(phoneRegex, 'Téléphone invalide'),
  password: z
    .string()
    .min(passwordMinLength, `Au moins ${passwordMinLength} caractères`)
    .max(200),
  clientType: clientTypeSchema,
});
export type SignupInput = z.infer<typeof signupSchema>;

export const loginSchema = z.object({
  email: z.string().trim().toLowerCase().email('Email invalide'),
  password: z.string().min(1, 'Mot de passe requis'),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const publicUserSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  firstName: z.string(),
  lastName: z.string(),
  phone: z.string(),
  role: userRoleSchema,
  clientType: clientTypeSchema.nullable(),
  permissions: permissionSchema.array(),
  emailVerified: z.boolean(),
  active: z.boolean(),
  createdAt: z.string().datetime(),
});
export type PublicUser = z.infer<typeof publicUserSchema>;

export const authResponseSchema = z.object({
  token: z.string(),
  user: publicUserSchema,
});
export type AuthResponse = z.infer<typeof authResponseSchema>;
